import { CurrencyBalance } from "@/components/l10n/Currency.tsx";
import { DetailsTable } from "@/components/table/DetailsTable.tsx";
import { DetailsTableRow } from "@/components/table/DetailsTableRow.tsx";
import { invoiceName, reportIdTitle } from "@/modules/billing/invoice/invoiceLogic.tsx";
import { useLingui } from "@lingui/react/macro";
import type { BillingAccountInvoice } from "@warrenio/api-spec/spec.oats.gen";

export function InvoicePaymentInfo({ invoice }: { invoice: BillingAccountInvoice }) {
    const { t } = useLingui();
    const documentNumber = reportIdTitle(invoice);
    const name = invoiceName(invoice, "long");

    const { totals } = invoice;

    return (
        <DetailsTable>
            <DetailsTableRow title={t`Document No.`}>{documentNumber}</DetailsTableRow>
            <DetailsTableRow title={t`Invoice name`}>{name}</DetailsTableRow>
            <DetailsTableRow title={t`Total`}>
                <CurrencyBalance value={totals.total_before_tax + totals.vat_tax} />
            </DetailsTableRow>
        </DetailsTable>
    );
}
